const icon1 =
  "https://winpeleadershipsummit.winpeforum.com/wp-content/uploads/2021/12/Picture1aa.jpg";
const icon2 = "https://winpeforum.com/assets/elements/ZiaMody_edit.jpg";
const icon4 = "https://winpeforum.com/assets/elements/Renuka-Ramnath.png";
const icon3 = "https://winpeforum.com/assets/elements/CDPQ_mem1.jpg";
const icon5 = "https://winpeforum.com/assets/elements/esterNew.jpg";
const icon6 = "https://winpeforum.com/assets/elements/matangi.jpg";
const icon7 = "https://winpeforum.com/assets/elements/shyamala.jpg";
const iconamb1 = "https://winpeforum.com/assets/elements/winpe_v_team1.png";
const iconamb2 = "https://winpeforum.com/assets/elements/winpe_v_team2.png";
const iconamb3 = "https://winpeforum.com/assets/elements/winpe_v_team3.png";
const iconamb4 = "https://winpeforum.com/assets/elements/Chandni.jpg";
const iconamb5 = "https://winpeforum.com/assets/elements/Krunali_1.JPG";
const iconamb6 = "https://winpeforum.com/assets/ambassadors/vidhi_jain_amb.jpg";

const iconamb7 =
  "https://winpeforum.com/assets/ambassadors/Aparna_Jain_amb.jpg";

const iconamb8 =
  "https://winpeforum.com/assets/ambassadors/priyanka_chandak_amb.jpg";
const iconamb9 =
  "https://winpeforum.com/assets/ambassadors/Sanchi_Khurana_amb.jpg";
const iconamb10 =
  "https://winpeforum.com/assets/ambassadors/Pooja_Parmar_amb.jpg";

const iconamb11 =
  "https://winpeforum.com/assets/ambassadors/Pooja_Sharoff_amb.jpg";

const iconamb12 =
  "https://winpeforum.com/assets/ambassadors/Ishita_Suri_amb.jpg";

const iconamb13 =
  "https://winpeforum.com/assets/ambassadors/Shikha_Pareek_amb.jpg";

const iconamb14 =
  "https://winpeforum.com/assets/ambassadors/Vidhi_Dosh_amb.jpg";

const iconamb15 =
  "https://winpeforum.com/assets/ambassadors/Swati_Bhartia_amb.jpg";

const iconamb16 =
  "https://winpeforum.com/assets/ambassadors/shivani_tannu_amb.jpg";
const iconamb17 =
  "https://winpeforum.com/assets/ambassadors/akanksha_gupta_amb.jpeg";
const iconamb18 =
  "https://winpeforum.com/assets/ambassadors/anshul_jain_amb.jpg";

const iconamb19 =
  "https://winpeforum.com/assets/ambassadors/shriya_basul_amb.jpeg";
  const iconamb20 =
  "https://winpeforum.com/assets/ambassadors/AditiKumar.jpg";
  const iconamb21 =
  "https://winpeforum.com/assets/ambassadors/KiranSharma.jpg";
  const iconamb22 =
  "https://winpeforum.com/assets/ambassadors/PrachiChavda.jpg";
  const iconamb23 =
  "https://winpeforum.com/assets/ambassadors/PrachiMalpani.jpg";
  const iconamb24 =
  "https://winpeforum.com/assets/ambassadors/SaakshiGera.jpg";
  const iconamb25 =
  "https://winpeforum.com/assets/ambassadors/ParitaAshar.jpeg";
  const iconamb26 =
  "https://winpeforum.com/assets/ambassadors/Guntas.jpeg  ";
const team_constants = [
  {
    imgUrl: icon1,
    // into:"Nupur Garg is a leading investor in private equity and venture capital and an expert advisor to large institutional investors. Nupur’s experience spans private equity investing, operations and finance in leading global organizations like IFC – an arm of the World Bank Group, Discovery Networks and PwC.",
    desc: `<div> Nupur Garg is a leading investor in private equity and venture capital and an expert advisor to large institutional investors. She is the founder of Winpe (https://winpeforum.com), an initiative to
    enhance gender diversity in the investing ecosystem.<br/><br/>
    
    
    Nupur serves as Chairperson of the board of Kids Clinic India Limited and an independent director on the boards of companies including Edelweiss Real Assets Managers Limited, Kerala Infrastructure Fund Management Limited and SIDBI, the Indian development finance institution. She is an independent member of the investment committee at the Fund of Funds managed by the National Investment and Infrastructure Fund (NIIF), the quasi-sovereign wealth fund sponsored by the government of India, and an advisor to and a member of the investment committee for the Dutch Good Growth Fund (DGGF) investment funds mandate given by the Dutch government for investments in SMEs in frontier markets across 75 countries. She has served as an external expert on the investment committee for the INR 10,000 crore Fund of Fund for Start-ups for investing in the Indian start-up ecosystem. Nupur advises select fund managers on a confidential basis on matters related to institutionalization, best practices and governance. She also mentors female entrepreneurs across various platforms.
    <br/><br/>
    
    Nupur is recognized as a thought and industry leader with a long list of recognitions that include the
    HerPower Award 2023, BW VC World Most Influential Women 2023 and 2022, Forbes W-Power list of
    Self Made Women 2020, India’s top 10 Women Leaders in Finance (AIWMI 2019), Vedica Women’s
    Alliance’s Women Leader in D&I 2022, Women Empowerment Entrepreneur Award 2019-20 and the
    Business Excellence and Innovative Best Practices - Academia Award 2019.
    <br/><br/>
    
    Prior to starting her entrepreneurial journey, Nupur led the private equity and venture capital funds
    business in the region for IFC and is widely credited with establishing IFC’s brand and credibility as one
    of the most respected institutional investors in this space. Under her stewardship, the portfolio doubled in
    size and returns, moving from a negative IRR to delivering gains for the first time in its history.
    <br/><br/>
    
    Nupur is a CA and an MBA from MIT Sloan School of Management, with executive education from
    Harvard Business School.
    
    <br/><br/>
    Nupur loves to spend time with her mother, husband and 8-year-old son, travel to new places, read and
    do 1500-piece puzzles.
				</div>`,
    name: "Nupur Garg",
    post: `<div>Founder, Winpe <br /> Investor & Independent Director</div>`,
    link: "https://www.linkedin.com/in/nupurgarg/",
  },
  {
    imgUrl: icon3,
    // into:"Anita M. George is Executive Vice-President and Deputy Head of CDPQ Global. She fills a key role in developing CDPQ’s activities in its three priority international areas: the United States/Latin America, Europe and Asia Pacific. She actively participates in positioning CDPQ internationally, as well as developing and executing its globalization strategy.",
    desc: `<div>Anita has been an investor backing early trends with winning partners and established a distinguished track record in sustainable investments across the globe. In her last five and a half years with CDPQ, she established CDPQ's office in India and soon after became Executive Vice President and Head of Emerging Markets at CDPQ. Her final post at CDPQ was as Executive Vice President and Deputy Head of CDPQ Global covering all geographies outside of Canada, supporting investments in renewable energy, highways, telecom, and venture fund investments in Emerging Markets. Anita spent 22 years at the World Bank Group with 14 of those years with the IFC in Infrastructure and Natural Resources, Municipal Finance and initiated the creation of IFC's Venture group. Her various roles have led her to work in several regions of the world, including Europe, Asia, the Middle East, Africa and Latin America.
   <br/><Br/>
    Ms. George holds a BA in Economics and Spanish from Smith College, in Massachusetts, and a Masters in Economics and an MBA in Finance from Boston University.
				</div>`,
    name: "Anita George",
    post: `<div>Global Sustainable Investment Professional    </div>`,
    link: "https://www.linkedin.com/in/anita-george-255778133/",
  },
  {
    imgUrl: icon4,
    // into:"Renuka Ramnath is the Founder, Managing Director and CEO of Multiples Alternate Asset Management, a private equity manager and advisor to funds of ~ USD 1.5 bn. She has over 30 years of experience in the Indian financial sector across private equity, investment banking and structured finance.",
    desc: `<div>Renuka Ramnath is the Founder, Managing Director and CEO of Multiples Alternate Asset Management, a private equity manager and advisor to funds of ~ USD 1.5 bn. She has over 30 years of experience in the Indian financial sector across private equity, investment banking and structured finance. 
		<br />
		<br />
		For close to three decades in financial services, Renuka successfully built several businesses in the ICICI Group including Investment Banking, e-commerce and private equity. As the MD & CEO of ICICI Venture for close to a decade, she led that firm to become one of the largest private equity funds in India.
		<br />
		<br />
		She is a Board member of EMPEA, the global industry association for private capital in emerging markets. She is also the Chairperson of the Executive Committee of  Indian Venture Capital Association.  Renuka has been featured in many prestigious listings, including the Top 25 Most Powerful Women in Business (Business Today, India); India's most Powerful CEO's (Economic Times), the Top 25 Non Bank Women in Finance (US Banker's global list), Asia's Women in the Mix: The Year's Top 50 for Achievement in Business (Forbes), Top 25 women in Asian asset management (Asian Investor) and most recently has been awarded the AVCJ Special Achievement Award, 2019.
		</div>`,
    name: "Renuka Ramnath",
    post: `<div>Member, Advisory Board, Winpe <br /> Founder, MD & CEO, Multiples Alternate Asset Management</div>`,
    link: "https://www.linkedin.com/in/renukaramnath/",
  },
  {
    imgUrl: icon2,
    // into:"Zia J. Mody, Co–Founder and Managing Partner of AZB & Partners, is one of India’s foremost corporate attorneys. Zia is widely acknowledged for her expertise, ranking No. 1 in Fortune India’s ‘India’s 50 Most Powerful Women in Business’ list in 2018 & 2019, on which she has consistently ranked in the top 10 since 2011.",
    name: "Zia J. Mody",
    desc: `<div>Zia J. Mody, Co–Founder and Managing Partner of AZB & Partners, is one of India’s foremost corporate attorneys. Zia is widely acknowledged for her expertise, ranking No. 1 in Fortune India’s ‘India’s 50 Most Powerful Women in Business’ list in 2018 & 2019, on which she has consistently ranked in the top 10 since 2011. 
		<br />
		<br />
		Zia has held and continues to hold several prestigious positions at global and national levels. She currently serves as a Member, Governing Board – International Council for Commercial Arbitration (ICCA) and Member – CII National Council. She was the Vice President & Member – London Court of International Arbitration (LCIA) and Member – World Bank Administrative Tribunal, Washington D.C.. In addition, Zia has served in various capacities on several committees and panels set up by Indian regulatory bodies including SEBI, RBI, Law Commission of India and Ministry of Corporate Affairs.
		<br />
		<br />
		Zia has been a recipient of numerous awards recognizing her individual and professional achievements as a legal practitioner and leader. She completed her masters in law from the Harvard Law School and is a member of the New York State Bar Association. Zia’s practice areas include Mergers & Acquisitions, Private Equity, Restructuring and General Corporate, Compliance & Investigation, Dispute Resolution, and Regulatory & Securities Law.
		</div>`,
    post: `<div>Member, Advisory Board, Winpe <br /> Co–Founder & Managing Partner, AZB & Partners</div>`,
    link: "https://www.linkedin.com/in/ziamody",
  },
  
  {
    imgUrl: icon6,
    // into:"Zia J. Mody, Co–Founder and Managing Partner of AZB & Partners, is one of India’s foremost corporate attorneys. Zia is widely acknowledged for her expertise, ranking No. 1 in Fortune India’s ‘India’s 50 Most Powerful Women in Business’ list in 2018 & 2019, on which she has consistently ranked in the top 10 since 2011.",
    name: "Matangi Gowrishankar",
    desc: `<div>Ms. Matangi Gowrishankar brings more than three decades of experience as a business, Human Resources and Change Management specialist. Passionate about leadership and organization development she has a track record in organization transformation and talent management both in India and overseas.
		<br />
		<br />
		She has worked with several large multinational organizations like Standard Chartered Bank, Reebok, GE, Cummins Inc and most recently, with the British Oil Major BP plc where her last assignment was Global Head of Capability Development and Director of the Leadership Academy. She has extensive, diverse experience having lived and worked in the UK and Singapore with a broad geographical remit across several countries.
		<br />
		<br />
		Ms. Gowrishankar has a BA in Sociology and a Post Graduate qualification in Human Resources from XLRI, a premier educational institution in India. She is a certified coach from the Neuroleadership Group (previously Results Coaching) Australia. Ms. Gowrishankar also holds certifications from SHL (Saville & Holdsworth) for designing and conduct of Assessment Centres, Instructional Design and Facilitation Skills from Skill Base UK.
		<br />
		<br />
		Today, with an independent organization development practice, Ms. Gowrishankar continues to work with BP and other organizations coaching, guiding and facilitating leaders to transform self and the organization to meet the challenges of doing business in a highly volatile and dynamic environment. She has experience in leading several D&I initiatives including highly successful development offers for women both in India and overseas. Her credo is to make a positive difference to individuals and organizations. She believes in enduring partnerships built on trust and mutual respect. She is committed to leveraging diversity of thought and the human spirit for achieving the best outcomes.
		<br />
		<br />
		Ms. Gowrishankar also holds Non - Executive Independent Directorships with 8 companies in India across diverse industries.
		<br />
		<br />
		She has been a regular speaker at Indian and global conferences and has contributed to several case study commentaries in Indian business magazines.
		<br />
		<br />
		Ms. Gowrishankar and her mother live in Pune, India. Her son, an event management specialist lives in Melbourne, Australia.
		</div>`,
    post: `<div>Member, Advisory Board, Winpe Proclub <br /> Independent Director, Strategic Advisor & Certified Coach</div>`,
    link: "https://www.linkedin.com/in/matangi-gowrishankar-0814a74/",
  },
  {
    imgUrl: icon7,
    // into:"Zia J. Mody, Co–Founder and Managing Partner of AZB & Partners, is one of India’s foremost corporate attorneys. Zia is widely acknowledged for her expertise, ranking No. 1 in Fortune India’s ‘India’s 50 Most Powerful Women in Business’ list in 2018 & 2019, on which she has consistently ranked in the top 10 since 2011.",
    name: "Shyamala Gopinath",
    desc: `<div>Ms. Shyamala Gopinath has 41 years of rich experience in financial sector policy formulation in different capacities at Reserve Bank of India (RBI). At RBI, she held key positions and guided & influenced national policies in diverse areas of financial sector regulation and supervision, the development and regulation of financial markets, capital account management, management of government borrowings, foreign exchange reserve management and payment and settlement systems.
		<br />
		<br />
		She has served on several committees while with RBI. During 2001 to 2003, she was deputed as Senior Financial Expert at the International Monetary Fund. Ms. Gopinath retired as Deputy Governor of RBI, a position that she held for nearly 7 years. She served as Chairperson Advisory Board on Bank, Commercial and Financial Frauds for two years from 2012 to 2014.
		<br />
		<br />
		Ms. Gopinath was also the Chairperson of the Board of Corporate Bonds and Securitisation Advisory Committee of SEBI.
		<br />
		<br />
		Since 2012, Ms. Gopinath has held several Board positions in large corporates and public sector undertakings such as Clearing Corporation of India, Indian Oil Corporation Limited, GAIL and Ernst & Young (Global Governance Council). Presently, Ms. Gopinath serves as Independent Director on the Boards of other renowned companies. She is a part-time Non-Executive Chairperson of HDFC Bank Ltd. and Chairperson of the Board of Governors of Indian Institute of Management, Raipur.
		</div>`,
    post: `<div>Member, Advisory Board, Winpe Proclub <br /> Non-Executive Chairperson, HDFC Bank Ltd</div>`,
    link: "https://www.linkedin.com/in/shyamala-gopinath-21b41578/",
  },
  // {
  // 	imgUrl: icon5,
  // 	// into:"Zia J. Mody, Co–Founder and Managing Partner of AZB & Partners, is one of India’s foremost corporate attorneys. Zia is widely acknowledged for her expertise, ranking No. 1 in Fortune India’s ‘India’s 50 Most Powerful Women in Business’ list in 2018 & 2019, on which she has consistently ranked in the top 10 since 2011.",
  // 	name:"Ester Martinez",
  // 	desc: `<div>Ms. Ester Martinez is the CEO & Editor-in-Chief at People Matters, the fastest-growing community for CHROs and business leaders committed to the advancement of talent & work practices for sustainable business impact.
  // 	<br />
  // 	<br />
  // 	In 2009, upon sensing the need for a platform to deliberate on talent management, leadership and hold critical insights on people & future of work for C-suite audience, Ms. Martinez founded People Matters and rapidly grew it to become one of the few successes in independent publishing and a brand synonymous to knowledge and digital innovation in people and work-tech space. And today the brand is a name to reckon with not just in India, but also globally, with a special focus on Southeast Asia.
  // 	<br />
  // 	<br />
  // 	A people’s person at heart, Ms. Martinez holds a Postgraduate degree in Human Resources Management from EADA (Spain) and a Master of Business Administration from Indian School of Business (ISB), Hyderabad.
  // 	<br />
  // 	<br />
  // 	With more than 15 years of experience in human resources, Ms. Martinez has a wealth of knowledge in the areas of talent, learning & development and work-tech. Until 2008, she worked as a professional manager with a host of blue chip companies such as Hewlett Packard and Tata Consultancy Services, both in India and the UK.
  // 	<br />
  // 	<br />
  // 	A much sought-after speaker on leadership and future of work, Ms. Martinez was recognized as a top influencer on employee engagement by The Employee Engagement Awards, and top influencer in HR Technology by Recruiting Daily. Ms. Martinez was also featured in the 2016 & 2018 LinkedIn Top Voices List, which ranks the top writers on LinkedIn for the year. She is also a renowned TEDx speaker and was nominated for the Global Employee Engagement Influencers 2017.
  // 	</div>`,
  // 	post:`</div>Member, Advisory Board, Winpe Proclub <br />CEO & Editor-in-Chief, People Matters</div>`,
  // 	link:"https://www.linkedin.com/in/estermartinez/"
  // },
  // {
  // 	imgUrl: icon6,
  // 	// into:"Zia J. Mody, Co–Founder and Managing Partner of AZB & Partners, is one of India’s foremost corporate attorneys. Zia is widely acknowledged for her expertise, ranking No. 1 in Fortune India’s ‘India’s 50 Most Powerful Women in Business’ list in 2018 & 2019, on which she has consistently ranked in the top 10 since 2011.",
  // 	name:"Matangi Gowrishankar",
  // 	desc: `<div>Ms. Matangi Gowrishankar brings more than three decades of experience as a business, Human Resources and Change Management specialist. Passionate about leadership and organization development she has a track record in organization transformation and talent management both in India and overseas.
  // 	<br />
  // 	<br />
  // 	She has worked with several large multinational organizations like Standard Chartered Bank, Reebok, GE, Cummins Inc and most recently, with the British Oil Major BP plc where her last assignment was Global Head of Capability Development and Director of the Leadership Academy. She has extensive, diverse experience having lived and worked in the UK and Singapore with a broad geographical remit across several countries.
  // 	<br />
  // 	<br />
  // 	Ms. Gowrishankar has a BA in Sociology and a Post Graduate qualification in Human Resources from XLRI, a premier educational institution in India. She is a certified coach from the Neuroleadership Group (previously Results Coaching) Australia. Ms. Gowrishankar also holds certifications from SHL (Saville & Holdsworth) for designing and conduct of Assessment Centres, Instructional Design and Facilitation Skills from Skill Base UK.
  // 	<br />
  // 	<br />
  // 	Today, with an independent organization development practice, Ms. Gowrishankar continues to work with BP and other organizations coaching, guiding and facilitating leaders to transform self and the organization to meet the challenges of doing business in a highly volatile and dynamic environment. She has experience in leading several D&I initiatives including highly successful development offers for women both in India and overseas. Her credo is to make a positive difference to individuals and organizations. She believes in enduring partnerships built on trust and mutual respect. She is committed to leveraging diversity of thought and the human spirit for achieving the best outcomes.
  // 	<br />
  // 	<br />
  // 	Ms. Gowrishankar also holds Non - Executive Independent Directorships with 8 companies in India across diverse industries.
  // 	<br />
  // 	<br />
  // 	She has been a regular speaker at Indian and global conferences and has contributed to several case study commentaries in Indian business magazines.
  // 	<br />
  // 	<br />
  // 	Ms. Gowrishankar and her mother live in Pune, India. Her son, an event management specialist lives in Melbourne, Australia.
  // 	</div>`,
  // 	post: `<div>Member, Advisory Board, Winpe Proclub <br /> Independent Director, Strategic Advisor & Certified Coach</div>`,
  // 	link:"https://www.linkedin.com/in/matangi-gowrishankar-0814a74/"
  // },
  // {
  // 	imgUrl: icon7,
  // 	// into:"Zia J. Mody, Co–Founder and Managing Partner of AZB & Partners, is one of India’s foremost corporate attorneys. Zia is widely acknowledged for her expertise, ranking No. 1 in Fortune India’s ‘India’s 50 Most Powerful Women in Business’ list in 2018 & 2019, on which she has consistently ranked in the top 10 since 2011.",
  // 	name:"Shyamala Gopinath",
  // 	desc: `<div>Ms. Shyamala Gopinath has 41 years of rich experience in financial sector policy formulation in different capacities at Reserve Bank of India (RBI). At RBI, she held key positions and guided & influenced national policies in diverse areas of financial sector regulation and supervision, the development and regulation of financial markets, capital account management, management of government borrowings, foreign exchange reserve management and payment and settlement systems.
  // 	<br />
  // 	<br />
  // 	She has served on several committees while with RBI. During 2001 to 2003, she was deputed as Senior Financial Expert at the International Monetary Fund. Ms. Gopinath retired as Deputy Governor of RBI, a position that she held for nearly 7 years. She served as Chairperson Advisory Board on Bank, Commercial and Financial Frauds for two years from 2012 to 2014.
  // 	<br />
  // 	<br />
  // 	Ms. Gopinath was also the Chairperson of the Board of Corporate Bonds and Securitisation Advisory Committee of SEBI.
  // 	<br />
  // 	<br />
  // 	Since 2012, Ms. Gopinath has held several Board positions in large corporates and public sector undertakings such as Clearing Corporation of India, Indian Oil Corporation Limited, GAIL and Ernst & Young (Global Governance Council). Presently, Ms. Gopinath serves as Independent Director on the Boards of other renowned companies. She is a part-time Non-Executive Chairperson of HDFC Bank Ltd. and Chairperson of the Board of Governors of Indian Institute of Management, Raipur.
  // 	</div>`,
  // 	post: `<div>Member, Advisory Board, Winpe Proclub <br /> Non-Executive Chairperson, HDFC Bank Ltd</div>`,
  // 	link:"#"
  // },
];

const ambassadors_team_current = [
  
  {
    imgUrl: iconamb20,
    name: "Aditi Kumar",
    desc: `<div>
    Aditi Kumar is an Asst. Vice President at HDFC's Venture Investment's arm. Prior to HDFC, she was part of the core M&A team at Delhivery, and also helped the company file for IPO. She has also worked as Investment Associate with Orios Venture Partners, as an Investment Analyst with NEA (New Enterprise Associates), and was a Consultant with the Guggenheim. Aditi earned her Economics and Mathematics degrees at New York University (NYU), minoring in Computer Science. Her thesis was an intersection of her majors and focused on, “gauging market sentiment with regards to commodity fluctuation”. She was also awarded the President's Service Award, based on her contributions to the NYU community during her time at NYU.
		</div>`,
    post: "AVP, Venture Investments, HDFC",
    designation: "AVP, Venture Investments",
    company: "HDFC",
    link: "https://www.linkedin.com/in/aditinkumar/",
  },
  {
    imgUrl: iconamb18,
    name: "Anshul Jain",

    desc: `<div>
    Anshul is the co-head of Investments at Lighthouse Funds and has led firm’s investments in Nykaa, Duroflex Mattress and Aqualite Footwear. Prior to joining Lighthouse Funds, Anshul has worked as an investment banker, advising clients on IPO, M&A and PE fundraising at ICICI Securities and ABN-Amro. Anshul holds a Master’s degree in Business Administration from IIM Indore.
		</div>`,
    post: "Managing Director, Lighthouse Advisors",
    designation: "Managing Director",
    company: "Lighthouse Advisors",
    link: "https://www.linkedin.com/in/anshul-jain-3584321/",
  },

  {
    imgUrl: iconamb7,
    name: "Aparna Jain",

    desc: `<div>
    Aparna Jain is a Manager in the Portfolio Management function at Multiples since 2020. In
her immediate previous role, she worked with Deloitte and EY in their Forensic Diligence
practice for more than 4 years. Prior to Forensics, she was with CRISIL in their Global Ratings
team for Structured Finance instruments. She is a Chartered Accountant and completed her
articles with PwC from 2011 to 2014. She graduated from H.R. College, Mumbai during the
same period.
		</div>`,
    post:
      "Senior Manager - Portfolio Management, Multiples Alternate Asset Management",
    designation: "Senior Manager - Portfolio Management",
    company: "Multiples Alternate Asset Management",
    link: "https://www.linkedin.com/in/aparna-jain-38813180/",
  },
  {
    imgUrl: iconamb26,
    name: "Guntas Sehmi",

    desc: `<div>
    Guntas Sehmi is currently working as an investment analyst with Multiples Alternate Asset Management. Prior to Multiples, she was a part of the core M&A and corporate development team of the infrastructure arm of JSW Group for ~3 years. Guntas has done her B.Com (Honors) from Shri Ram College of Commerce, University of Delhi and is a CFA Level II candidate. 
		</div>`,
    post:
      "Investment Analyst, Multiples Alternate Asset Management",
    designation: "Investment Analyst",
    company: "Multiples Alternate Asset Management",
    link: "https://in.linkedin.com/in/guntas-sehmi-9b2043131",
  },
  {
    imgUrl: iconamb21,
    name: "Kiran Sharma",

    desc: `<div>
    International investment professional, with about 7 years of experience investing in frontier and emerging markets along with deep experience in financial modelling, valuations, and investor relations. Responsible for building investment pipeline, evaluation of investment opportunities, investment due diligence of companies at start-up stage and growth stage. Play a key role in portfolio management for Indian companies.<br/><Br/>
Previously worked with Deloitte in financial advisory services in valuations and financial modelling practice. Have actively led marquee valuation engagements including publicly listed companies and fortune 500 companies. I have played an instrumental role in setting up the investor relations department and conceptualizing the investor relations strategy at Gati Limited (Leading Logistics Company in India).I hold an Executive MBA from Narsee Monjee Institute of Management Studies and B Com from M S University Vadodara

		</div>`,
    post:
      "Impact Investments, Accion",
    designation: "Impact Investments",
    company: "Accion",
    link: "https://www.linkedin.com/in/kiran-sharma-she-her-822a4956/",
  },
  {
    imgUrl: iconamb25,
    name: "Parita Asar",
    desc: `<div>
    I currently work as a Vice- President with Oman India Joint Investment Fund Management Co. Pvt. Ltd. (OIJIF), an India focussed mid-market growth private equity fund. My role covers the entire deal cycle including sourcing, evaluation, deal structuring and negotiation of transaction documents, deal execution, monitoring and exits. Over the 5.5 years at OIJIF, I have evaluated deals across financial services, consumer, electrical vehicles and industrials. Prior to that, I have worked for 6.5 years at the equity research desk of the institutional equities division of Ambit Capital, a domestic financial services firm. I am a Chartered Accountant and a Chartered Financial Analyst by education.

    </div>`,
    post: "Vice-President, Oman India Joint Investment Fund Management Co. Pvt. Ltd.",
    designation: "Vice-President",
    company: "Oman India Joint Investment Fund Management Co. Pvt. Ltd.",

    link: "https://in.linkedin.com/in/parita-ashar-cfa-28a9b23b",
  },
  {
    imgUrl: iconamb10,
    name: "Pooja Parmar",
    desc: `<div>
    Pooja is Senior Associate at Equanimity. She has been working at Equanimity for more than 5 years. Prior to Equanimity she has worked with Housing.com as a finance business partner to the product, tech and design teams. She has done her articleship with PwC in the financial services group. Pooja is a Chartered Accountant and a commerce graduate from Narsee Monjee College.

    </div>`,
    post: "Senior Associate, Equanimity Investments",
    designation: "Senior Associate",
    company: "Equanimity Investments",

    link: "https://www.linkedin.com/in/pooja-parmar-69712789/",
  },
  {
    imgUrl: iconamb22,
    name: "Prachi Chavda",
    desc: `<div>
    Prachi Chavda, an alumna of IIT Bombay, class of 2017, is part of the investment team at Jackdaw Capital. She previously worked at IIM-Ahmedabad’s incubator, CIIE.CO, in sector research for blockchain, biotech, InsurTech & other sectors. Prior to this, she worked with RBL Bank (India) across payments, fintech-bank partnerships, and digital banking products.

    </div>`,
    post: "Core Team, SoulUp",
    designation: "Core Team",
    company: "SoulUp",

    link: "https://www.linkedin.com/in/prachi-chavda-77713781/",
  },
  {
    imgUrl: iconamb23,
    name: "Prachi Malpani",
    desc: `<div>
    Prachi is an investment analyst currently helping with sourcing deals across deep tech B2B space. She has expertise in market research.


    </div>`,
    post: "Investment Analyst, Mela Ventures",
    designation: "Investment Analyst",
    company: "Mela Ventures",

    link: "https://www.linkedin.com/in/prachi-malpani-a9709758/",
  },
  
  {
    imgUrl: iconamb2,
    name: "Rochelle D'Souza",
    desc: `<div>Rochelle D'Souza is Managing Director at Lighthouse Advisors. Prior to Lighthouse Advisors, she was a Manager at SBI Capital Markets, Investment Banking Division, where she focused on equity capital market transactions.
		<br />
		<br />
		Rochelle earned a Bachelor of Engineering in Electronics & Communication from Rashtreeya Vidyalaya College of Engineering (RVCE) and an MBA from S.P. Jain Institute of Management & Research. She is also a CFA Level III candidate.
		</div>`,
    post: "Managing Director, Lighthouse Advisors",
    designation: "Managing Director",
    company: "Lighthouse Advisors",
    link: "https://in.linkedin.com/in/rochelle-dsouza-448169b",
  },
  {
    imgUrl: iconamb24,
    name: "Saakshi Gera",
    desc: `<div>
    Saakshi joined Kedaara Capital in November 2020 and has 11 years of experience in investing / investment banking. Prior to joining Kedaara Capital, Saakshi served as an Executive Director at Goldman Sachs, Principal Investing Arm (India office), where she focused on investments in financial services, IT services and energy sector. Some of the investments she worked on include Max Financial, ReNew Power, Noveltech Feeds, and BPL Medical. Previously, she was part of the investment team at Providence Equity Partners and GTI Capital. She started her career with investment banking at Nomura. Saakshi has completed all levels of the CFA program (USA). She has done BA Economics from Delhi University, where she was a rank holder. 
    </div>`,
    post: " Principal, Kedaara Capital",
    designation: "Principal",
    company: "Kedaara Capital",
    link: "https://www.linkedin.com/in/saakshi-gera-424aa639/",
  },
  {
    imgUrl: iconamb9,
    name: "Sanchi Khurana",
    desc: `<div>
    Sanchi is part of the Ventures Team at Recharge Capital, an asset management firm based out of New York with USD 6B in AUM. At Recharge, Sanchi looks at global fintech investments at the Seed/Series-A stage. Prior to Recharge, Sanchi was part of the Investments Team at Kalaari Capital, a leading early-stage tech VC fund based out of India with USD 1Bn+ in AUM. Sanchi holds an undergraduate degree from Shri Ram College of Commerce (B.Com Hons).

    </div>`,
    post: "Investment Professional, HOF Capital",
    designation: "Investment Professional",
    company: "HOF Capital",
    link: "https://www.linkedin.com/in/sanchi-khurana-a365b0b8/",
  },
  {
    imgUrl: iconamb13,
    name: "Shikha Pareek",
    desc: `<div>
    Shikha is an Investment Professional with the Credit and Special Situations team at KKR India. Previously, she was part of the India investment banking team at Bank of America and UBS respectively and has worked across sectors including consumer retail, health-care and technology. She is a Chartered Accountant by training
    </div>`,
    post: "Investment Professional, KKR & Co. India",
    designation: "Investment Professional",
    company: "KKR & Co. India",
    link: "https://www.linkedin.com/in/shikha-pareek/",
  },
  
  
  {
    imgUrl: iconamb6,
    name: "Vidhi Jain",
    desc: `<div>Vidhi is an Investment Professional at HDFC. Prior to this, she worked as an Associate with the Edelwiess Investment Banking team aligned to the FIG Sector. Started her professional career with Deloitte in their Financial Due Diligence Team. She completed her Masters in Finance from Cranfield University, UK and has a Bachelors in Commerce and Business Administration.
		</div>`,
    post: "Investment Professional",
    designation: "Investment Professional",
    company: "",
    link: "https://www.linkedin.com/in/vidhi-jain-8168bb99",
  },
  
 
];

const ambassadors_team_previous = [
  {
    imgUrl: iconamb17,
    name: "Akanksha Gupta",

    desc: `<div>
    Akanksha Gupta is an investment professional with 5+ years of experience working across diverse sectors (consumers, mid-caps and financial services). She is currently working with a large US bank. Prior to that she worked with HSBC. She holds PGDM in Finance from IIM Ranchi and B.E from PEC-UT. She is FRM charterholder and CFA Level 3 candidate. 
  	</div>`,
    // post: "Associate, JP Morgan Chase",
    post: "Equity Research Analyst",
    designation: "Equity Research Analyst",
    company: "",
    // company: "JP Morgan Chase",
    link: "https://www.linkedin.com/in/akanksha-gupta-frm-75532476/",
  },
  {
    imgUrl: iconamb4,
    name: "Chandni Chetani",
    desc: `<div>Chandni is an Investment Professional at SSG Advisors. Before joining SSG, she was an Analyst at Moelis & Company, where she focused on M&A deals across sectors. Prior to that, she worked with JP Morgan’s Investment Banking Team. She is a CA, CS and a CFA Level III candidate.
		</div>`,
    post: "Investment Professional, SSG Advisors",
    designation: "Investment Professional",
    company: "SSG Advisors",
    link: "https://www.linkedin.com/in/chandni-chetani-3a6b32105/",
  },
  {
    imgUrl: iconamb5,
    name: "Krunali Shah",
    desc: `<div>Krunali Shah is an Investment Associate at A91 Partners. She did her summer internship with Multiples in 2019 and was at Boston Consulting Group as an Associate in 2018. Prior to that, she completed her three years of articleship from Baker Tilly DHC in the valuations division. Krunali graduated from Narsee Monjee College, Mumbai in 2016 and completed her MBA from IIM Ahmedabad in 2020 where she earned a gold medal for all round performance. She is also a rankholder Chartered Accountant.
		</div>`,
    post: "Investment Associate, A91 Partners",
    designation: "Investment Associate",
    company: "A91 Partners",
    link: "https://www.linkedin.com/in/krunali-shah-397a52a6/",
  },

  {
    imgUrl: iconamb12,
    name: "Ishita Suri",
    desc: `<div>
    Prior to joining Amicus Capital in 2020, Ishita worked at J.P. Morgan for over three years with the Financial Institutions Group as an investment banking analyst. During this tenure, Ishita was involved in Mergers & Acquisitions and Capital market transactions for companies across Banking, Insurance and other financial services.
    <br/><br/>
Ishita holds a Bachelor of Engineering in Electronics and Communication from PEC University of Technology, Chandigarh and has cleared the CFA Level II examination.

    </div>`,
    post: "Analyst, Amicus Capital",
    designation: "Analyst",
    company: "Amicus Capital",
    link: "https://www.linkedin.com/in/ishitasuri/",
  },
  {
    imgUrl: iconamb1,
    desc: `Nitya Khemlani is the Head of Investor Relations at Lighthouse. Previously Nitya worked as a Conference Producer for PEI Media (Hong Kong), organizing conferences and investor round tables across the private equity, private real estate and infrastructure asset classes in Asia. Nitya was also earlier a Research Associate for Linneman Associates, where she focused on researching and analyzing economic trends with a focus on the U.S. housing sector.
		<br />
		<br />
		Nitya earned a Bachelor of Science in International Business Management and Economics (magna cum laude) from the University of Tampa and a Masters in Economics from the University of Warwick.
		</div>`,
    name: "Nitya Khemlani",
    post: "Head of Investor Relations, Lighthouse Advisors",
    designation: "Head of Investor Relations",
    company: "Lighthouse Advisors",
    link: "https://in.linkedin.com/in/nitya-khemlani-461b49ab/de",
  },
  {
    imgUrl: iconamb11,
    name: "Pooja Sharoff",
    desc: `<div>
    Pooja Sharoff is an Associate in the SSG team at KPMG India. Previously, she has worked at EY focusing on M&A Advisory in the Financial Services sector; and at Tata Strategic Management Group. She completed her MBA from Indian School of Business and her Masters in Commerce from Mumbai University. She is also a CFA Level III Candidate.
    </div>`,
    post: "Senior Associate - SSG Team, KPMG India",
    designation: "Senior Associate - SSG Team",
    company: "KPMG India",
    link: "https://www.linkedin.com/in/pooja-sharoff-9555192b/",
  },

  {
    imgUrl: iconamb8,
    name: "Priyanka Chandak",
    desc: `<div>
    Priyanka Chandak is a Venture Capital Fellow at Kalaari Capital and has previously worked at Hindustan Unilever Ltd. supporting the sales function as a finance business partner. She completed her Bachelor’s in Commerce from St. Xavier’s College, Kolkata in 2017 and qualified as a Chartered Accountant in 2019. As an active advocate of equities investing, she is passionate about discussing personal finance. In her leisure time, she engages in meeting new people, reading and refining her public speking skills. 
    </div>`,
    post: "Venture Capital Fellow, Kalaari Capital",
    designation: "Venture Capital Fellow",
    company: "Kalaari Capital",
    link: "https://www.linkedin.com/in/priyankachandak/",
  },
  {
    imgUrl: iconamb2,
    name: "Rochelle D'Souza",
    desc: `<div>Rochelle D'Souza is a Principal at Lighthouse Advisors. Prior to Lighthouse Advisors, she was a Manager at SBI Capital Markets, Investment Banking Division, where she focused on equity capital market transactions.
		<br />
		<br />
		Rochelle earned a Bachelor of Engineering in Electronics & Communication from Rashtreeya Vidyalaya College of Engineering (RVCE) and an MBA from S.P. Jain Institute of Management & Research. She is also a CFA Level III candidate.
		</div>`,
    post: "Principal, Lighthouse Advisors",
    designation: "Principal",
    company: "Lighthouse Advisors",
    link: "https://in.linkedin.com/in/rochelle-dsouza-448169b",
  },
  {
    imgUrl: iconamb16,
    name: "Shivani Tannu",
    desc: `<div>
    Shivani Tannu is an Investment Banking Associate at Avendus Capital, Mumbai. Prior to this, she earned her Master of Business Administration (MBA) at the Indian Institute of Management (IIM), Bangalore. 
    She has completed all levels of the Chartered Accountancy course in 2015. She was selected as part of ‘Goldman Sachs’ Women Emerging in Finance’ cohort of 2020 and was also awarded the ‘Women in Banking’ Scholarship by Citi Bank, NA. 
    During her free time she likes to read books and keep up with the Indian startup ecosystem.
    </div>`,
    post: "Investment Banking Associate, Avendus Capital",
    designation: "Investment Banking Associate",
    company: "Avendus Capital",
    link: "https://www.linkedin.com/in/shivanitannu/",
  },
  {
    imgUrl: iconamb19,
    name: "Shriya Bahul",
    desc: `<div>With a background in development economics and finance, Shriya has always been passionate
    about working in the impact space. Her current work entails focusing on investments that
    promote access to finance, clean and green energy and women owned businesses. She strongly
    believes that investing in women can have a multiplier effect on the economy by not only
    encouraging other younger women but also enabling investors to generate additional revenue
    streams. At Winpe she hopes to collaborate closely with Women Entrepreneurs to help them
    scale businesses and facilitate them in the fundraising processes.</div>`,
    post: "Investment Analyst, IFC",
    designation: "Investment Analyst",
    company: "IFC",
    link: "https://www.linkedin.com/in/shriya-bahul-8512517a/",
  },
  {
    imgUrl: iconamb3,
    name: "Sreeja Vasantham",
    desc: `<div>Sreeja is an Investment Professional at General Atlantic and focuses on firm’s investments in India and Asia Pacific. Before joining General Atlantic, she was an Analyst at Moelis & Company, where she worked across sectors. Prior to that, she worked in Citi India’s investment banking arm. She graduated from IIT Bombay in 2016 with a Bachelors in Electrical Engineering.
		</div>`,
    post: "Investment Professional, General Atlantic",
    designation: "Investment Professional",
    company: "General Atlantic",
    link: "https://in.linkedin.com/in/sreeja-vasantham-ba449974",
  },
  {
    imgUrl: iconamb15,
    name: "Swati Bhartia",
    desc: `<div>Swati is a Vice President at Tata Capital Healthcare Fund. She has over 15 years of experience in private equity investments and equity research domain. Before joining Tata Capital she was working with Oman India Joint Investment Fund (OIJIF), where she was involved in deal evaluation, execution and monitoring investments in diverse sectors such as healthcare, machine tools, auto ancillaries, specialty chemicals and pharmaceuticals. Prior to that, Swati worked with Eredene Capital, an AIM listed USD 100 Mn PE fundShe started her career with Crisil as equity Research Analyst in 2005, covering European mid & large-cap Biotech companies. Swati is a 37th rank-holder Chartered Accountant and a CFA charter-holder.
		</div>`,
    post: "Vice President - Healthcare Fund, Tata Capital Limited",
    designation: "Vice President - Healthcare Fund",
    company: "Tata Capital Limited",
    link: "https://www.linkedin.com/in/swati-bhartia-24a8418/",
  },
  {
    imgUrl: iconamb14,
    name: "Vidhi Doshi",
    desc: `<div>Vidhi has over 4+ years of experience in the investment space, where she helped identify, support, and scale businesses across angel syndicate and private equity firms. She has closed 30+ deals, including Innov8 and Purple Style Labs, across various sectors during her career. Originally from Kolkata, she has lived and worked in Mumbai, Bangalore and Gurugram.</div>`,
    post: "Investment Analyst, Eximius Ventures",
    designation: "Investment Analyst",
    company: "Eximius Ventures",
    link: "https://www.linkedin.com/in/vidhi-doshi-118965134/",
  },
  
   
];

export { team_constants, ambassadors_team_current, ambassadors_team_previous };



// WEBPACK FOOTER //
// ./src/constant/team_constants.js